const search = window.location.search.substring(1);
const convertPathname = (pathname: string) => {
  return {
    pathname: `${pathname ? '/' + pathname : ''}`,
    search: '?' + search,
  };
};

export const PATH = {
  DEFAULT: convertPathname('home'),
  ANALYTICS: convertPathname('analytics'),
  TRANSLATION: convertPathname('translation'),
  GENERAL_SETTINGS: convertPathname('general-settings'),
  GEOLOCATION_VALIDITY: convertPathname('general-settings/geolocation-validity'),
  DISPLAY_POSITION: convertPathname('general-settings/display-position'),
  PRICING_PLAN: convertPathname('pricing-plan'),
  WELCOME: convertPathname('onboarding'),
  RULE_SETUP: convertPathname('settings/rule'),
  APPEARANCE: convertPathname('settings/appearance'),
  CREATE_RULE: convertPathname('settings/rule/create'),
  EDIT_RULE: convertPathname('settings/rule/edit/:id'),
  FEEDBACK: convertPathname('feedback'),
  CHECKOUT_EXTENSION: convertPathname('checkout-extension'),
  CREATE_CHECKOUT_EXTENSION: convertPathname('checkout-extension/create'),
  EDIT_CHECKOUT_EXTENSION: convertPathname('checkout-extension/edit/:id'),
  EDIT_CHECKOUT_APPEARANCE: convertPathname('checkout-extension/edit-appearance'),
  EDIT_CHECKOUT_PRODUCT_LINE_ITEMS: convertPathname('checkout-extension/edit-line-items'),
  EXIT_IFRAME: convertPathname('exit-iframe'),
};

export const USER_GUIDE_LINK = {
  DATE_SETUP: 'https://synctrack.io/knowledge-base/edd/estimate-rule/create-estimate-delivery-date-rules/',
  GUIDE_LINK: 'https://help.omegatheme.com/en/category/synctrack-estimated-delivery-date-1cr9tnj/',
  RULE_SETUP: 'https://synctrack.io/knowledge-base/edd/estimate-rule/create-estimate-delivery-date-rules/',
  CHECKOUT_RULE_SETUP: 'https://help.omegatheme.com/en/article/dynamic-delivery-date-checkout-extension-1x2fqy9/',
  EMBED_APP: 'https://synctrack.io/knowledge-base/edd/general-settings/embed-app/',
  SHOW_MESSAGE_TEXT_IN_EMAIL: 'https://help.omegatheme.com/en/article/display-position-xapawd/#3-show-message-text-in-email',
};
